var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLocaleKoKr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 3H3.75C2.09315 3 0.75 4.34315 0.75 6V18C0.75 19.6569 2.09315 21 3.75 21H20.25C21.9069 21 23.25 19.6569 23.25 18V6C23.25 4.34315 21.9069 3 20.25 3Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M20.25 3H3.75C2.09325 3 0.75 4.34325 0.75 6V18C0.75 19.6568 2.09325 21 3.75 21H20.25C21.9068 21 23.25 19.6568 23.25 18V6C23.25 4.34325 21.9068 3 20.25 3ZM22.5 18C22.5 19.2405 21.4905 20.25 20.25 20.25H3.75C2.5095 20.25 1.5 19.2405 1.5 18V6C1.5 4.7595 2.5095 3.75 3.75 3.75H20.25C21.4905 3.75 22.5 4.7595 22.5 6V18Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.92871 9.32837L6.81455 6.4996L7.2857 6.8137L5.39986 9.64247L4.92871 9.32837Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.63623 9.80029L7.52207 6.97153L7.99322 7.28563L6.10738 10.1144L5.63623 9.80029Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3418 10.2714L8.22764 7.4426L8.69878 7.7567L6.81295 10.5855L6.3418 10.2714Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7358 15.6536L18.5999 14.3574L19.0711 14.6715L18.207 15.9677L17.7358 15.6536Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7139 17.1862L17.5784 15.8894L18.0495 16.2035L17.185 17.5003L16.7139 17.1862Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0283 15.1821L17.8924 13.886L18.3636 14.2001L17.4995 15.4962L17.0283 15.1821Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0068 16.7147L16.8709 15.4186L17.3421 15.7327L16.478 17.0288L16.0068 16.7147Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3218 14.7111L17.1859 13.4149L17.657 13.729L16.7929 15.0252L16.3218 14.7111Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3003 16.2424L16.1644 14.9463L16.6355 15.2604L15.7714 16.5565L15.3003 16.2424Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.17188 10.1145C10.2136 8.55221 12.3241 8.12996 13.8864 9.17171C15.4486 10.2135 15.8709 12.324 14.8291 13.8862L9.17188 10.1145Z",
    fill: "#BE3B3E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M9.17159 10.1145C8.12984 11.6768 8.55209 13.7873 10.1143 14.829C11.6766 15.8708 13.7871 15.4485 14.8288 13.8863C15.3493 13.1055 15.1386 12.0495 14.3571 11.529C13.5756 11.0085 12.5203 11.2193 11.9998 12.0008L9.17159 10.1153V10.1145Z",
    fill: "#1C449C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5857 12.7568C11.5243 12.7568 12.2852 11.9959 12.2852 11.0573C12.2852 10.1187 11.5243 9.35779 10.5857 9.35779C9.64712 9.35779 8.88623 10.1187 8.88623 11.0573C8.88623 11.9959 9.64712 12.7568 10.5857 12.7568Z",
    fill: "#BE3B3E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M4.92871 14.6716L5.39986 14.3575L7.2857 17.1863L6.81455 17.5004L4.92871 14.6716Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M6.34375 13.7292L6.8149 13.4151L8.70074 16.2439L8.22959 16.558L6.34375 13.7292Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0078 7.28564L16.479 6.97155L18.3648 9.80031L17.8937 10.1144L16.0078 7.28564Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M5.63574 14.1998L6.10689 13.8857L6.97097 15.1819L6.49982 15.496L5.63574 14.1998Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M6.65674 15.7323L7.12788 15.4182L7.99199 16.7143L7.52084 17.0284L6.65674 15.7323Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2998 7.75696L15.771 7.44286L16.635 8.73899L16.1639 9.05309L15.2998 7.75696Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3218 9.28906L16.7929 8.97496L17.657 10.2711L17.1859 10.5852L16.3218 9.28906Z",
    fill: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7139 6.81458L17.185 6.50048L18.0491 7.7966L17.578 8.1107L16.7139 6.81458Z",
    fill: "black"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7358 8.34717L18.207 8.03306L19.0711 9.32917L18.5999 9.64328L17.7358 8.34717Z",
    fill: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M20.25 3.75H3.75C2.50725 3.75 1.5 4.75725 1.5 6V6.75C1.5 5.50725 2.50725 4.5 3.75 4.5H20.25C21.4927 4.5 22.5 5.50725 22.5 6.75V6C22.5 4.75725 21.4927 3.75 20.25 3.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocaleKoKr);
export default __webpack_public_path__ + "static/media/icon-locale-ko-KR.8fea4989f012bddb214f2f0f85f057bc.svg";
export { ForwardRef as ReactComponent };